const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindAllCompaniesQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
const companiesSearchSchema = createTableQuerySchema({});
export const Route = createFileRoute('/_rootLayout/companies/')({
  validateSearch: search => companiesSearchSchema.parse(search),
  loader: ({
    context: {
      queryClient
    },
    location
  }) => {
    const search = companiesSearchSchema.parse(location.search);
    queryClient.ensureQueryData(getFindAllCompaniesQueryOptions(search));
    return {
      crumb: t('NAVIGATION.COMPANIES'),
      to: '/companies'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});